<template>

    <div class="custom-select py-5">
        <select name="order" @change="orderChanged" id="orderFilter">
            <option value="">Zoradiť od</option>
            <option value="price-asc">Od najlacnejších</option>
            <option value="price-desc">Od najdrahších</option>
            <option value="new-desc">Od najnovších</option>
        </select>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                sort: ''
            }
        },

        mounted() {
            this.$root.$on('setValuesFromParameters', ( {order} ) => this.sort = order );

            setTimeout( () => this.setSelectedOption(), 50);
        },

        methods: {
            orderChanged() { this.$emit('onOrderChanged') },

            setSelectedOption() {
                Array.from(document.querySelector('#orderFilter').options).forEach( (option) => {
                    if ( option.value === this.sort )
                        option.setAttribute('selected', true);
                })
            }
        }
    }
</script>

<style scoped>
    select {
        border-color: #E0E0E0;
    }
</style>
